export default __webpack_public_path__ + "a00cba9decee74f4d88d7230046065eb.png";